var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zzl-container"},[_c('div',{staticClass:"zzl-content"},[_c('div',{staticClass:"zzl-title"},[_vm._v("管理")])])])}]

export { render, staticRenderFns }